export const LANGUAGES = [
	'English',
	'Hindi',
	'Spanish',
	'French',
	'German',
	'Chinese (Mandarin)',
	'Japanese',
	'Korean',
	'Arabic',
	'Portuguese',
	'Russian',
	'Italian',
	'Dutch',
	'Turkish',
	'Polish',
	'Swedish',
	'Thai',
	'Vietnamese',
	'Indonesian',
	'Greek',
	'Hebrew',
	'Persian',
	'Bengali',
	'Punjabi',
	'Marathi',
	'Gujarati',
	'Tamil',
	'Telugu',
	'Kannada',
	'Malayalam'
];